module.exports = __webpack_public_path__ + "static/media/share.9fe0cb91.svg";